import React from "react";
import { string, array, shape, arrayOf, object } from "prop-types";

import ListItem from "../../ListItem/ListItem.jsx";

const propTypes = {
  results: arrayOf(
    shape({
      imageSrcSquare: string,
      title: string,
      taxonomy: array,
      contentUrl: string,
    }),
  ),
  focusRef: object,
};

const SimpleList = (props) => {
  const { results, focusRef } = props;

  if (!results || results.length < 1) {
    return null;
  }

  return (
    <section className="simple-list">
      {results.map((result, i) => (
        <div key={result.key} className="simple-list__item">
          <ListItem
            {...result}
            imagePosition="right"
            media={result.imageSrcSquare}
            sizes="270px"
            link={{
              href: result.contentUrl,
              text: "",
            }}
            focusRef={i === 0 ? focusRef : null}
          />
        </div>
      ))}
    </section>
  );
};
SimpleList.propTypes = propTypes;
export default React.memo(SimpleList);
